import Fragment from "../../football/fragments/fragment";
import FragmentDataType from "../../football/enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";

export default class FlagPatFumbled extends Fragment {
    constructor(returnedBy, patScoreType) {
        super();
        this.result = "F";
        this.returnedBy = returnedBy;
        this.patScoreType = patScoreType;

        this.requiredData = [
            {
                name: "returnedBy",
                type: FragmentDataType.Player,
                displayName: "Returned by",
                isEditable: true
            },
            {
                name: "patScoreType",
                type: FragmentDataType.PatScoreType,
                displayName: "Score type"
            }
        ];
    }

    getFragmentTeamId() {
        return this.returnedBy?.teamId;
    }

    getPlayers() {
        return [this.returnedBy];
    }

    toJSON() {
        return {
            ...super.toJSON(),
            returnedBy: playerReducer(this.returnedBy)
        };
    }
}
